<template>
  <section class="report-section">
    <b-row>
      <b-col>
        <h3>1.2 Indicatori di performance</h3>
        <p>Si riporta confronto indici di performance del mese in analisi con stesso mese
          dell'anno precedente</p>
      </b-col>
    </b-row>
    <b-row style="margin-top:80px">
      <b-col>
        <b-table :items="table" :fields="fields">
          <template slot="color" slot-scope="row">
            <span class="legend" :style="{ color: $store.state.colors[row.index] }">■</span>
          </template>
          <template slot="deltaMonth" slot-scope="row">
            {{ ff(row.item.deltaMonth) }}
          </template>
          <template slot="euroMonth" slot-scope="row">
            {{ sign(row.item.euroMonth) }}{{ f(row.item.euroMonth) }}
          </template>
          <template slot="euroYear" slot-scope="row">
            {{ sign(row.item.euroYear) }}{{ f(row.item.euroYear) }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <apexchart type="line" :options="chart.options" :series="chart.series" />
      </b-col>
    </b-row>
  </section>
</template>

<script>
var moment = require('moment');

export default {
  name: "IndicatoriPerformance",
  props: ['siteGuid', 'month', 'ipg'],
  data() {
    return {
      table: [],
      fields: [
        { key: 'color', label: '' },
        { key: 'name', label: 'Indicatore' },
        { key: 'deltaMonth', label: 'Scostamento mese' },
        { key: 'euroMonth', label: 'Δ€ Mese' },
        { key: 'euroYear', label: 'Δ€ Cumulato ' + moment().format('YYYY') },
      ],
      chart: {
        options: {
          colors: this.$store.state.colors,
          chart: {
            animations: {
              enabled: false,
              toolbar: {
                show: false
              },
            },
            height: 400,
            width: 940,
          },
          dataLabels: {
            enabled: true,
            formatter: (v) => this.f(v, 3)
          },
          xaxis: {
            categories: []
          },
          yaxis: [],
          markers: {
            size: 4,
            shape: "square"
          },
        },
        series: []
      }
    }
  },
  created() {
    this.refresh()
  },

  methods: {
    refresh() {
      let data = this.ipg
      var options = _.cloneDeep(this.chart.options)

      options.xaxis.categories = []
      data.months.forEach((m,i) => {
        if(i > 12)
          options.xaxis.categories.push(moment(m, 'MM-YYYY').format('MMM YY'))
      })



      this.table = []

      options.yaxis = []
      data.items.forEach(item => {
        var row = {}
        row.name = item.name
        options.yaxis.push({
          labels: {
            formatter: (v) => this.f(v)
          },
          title: {
            text: item.name + " [" + item.mu + "]"
          }
        })

        var current = item.values.find(v => v.date == this.month)

        var prevMonth = moment(this.month, 'MM-YYYY').subtract(1, 'years').format('MM-YYYY')
        var prev = item.values.find(v => v.date == prevMonth)

        row.deltaMonth = current.parameterValue / prev.parameterValue * 100
        row.euroMonth = (current.IPG - prev.IPG) * current.parameterValue * current.cost

        row.euroYear = 0
        _.filter(item.values, { year: this.currentYear }).forEach(m => {
          var prev_month = item.values.find(v => v.month == m.month && v.year == m.year - 1)

          row.euroYear += (m.IPG - prev_month.IPG) * m.parameterValue * m.cost
        })

        this.table.push(row)

        this.chart.series = []
        var serie = { name: item.name + " Rolling", data: [] }
        /* CHART */
        // IL rolling invece è somma dei consumi dei mese analizzato +
        // la somma 11 mesi precedenti diviso il parametro del mese + la somma dei 12 mesi precedenti
        for(let i=0; i<24; i++) {
          var idx = (item.values.length - 24) + i

          var totParam = 0
          var totVector = 0
          for(let j=0; j<12; j++) {
            var el = item.values[idx - j]
            totParam += el.parameterValue
            totVector += el.value
          }

          serie.data.push(totVector / totParam)
        }

        this.chart.series.push(serie)
      })

      this.chart.options = options
    },
    ff(v) {
      if(v && ! isNaN(v)) {
        return this.sign(v) + v.toFixed(2) + "%"
      }
    },
    f(v, prec) {
      return this.$options.filters.formatDecimal(v, prec)
    },
    sign(v) {
      if(v > 0)
        return "+"
    }
  },

  watch: {
    ipg() {
      this.refresh()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Report/D_IndicatoriPerformance.vue